<template>
  <validation-observer ref="observer">
    <form @submit.prevent="submit" v-if="shaft" class="pt-2">
      <validation-provider
        v-slot="{ errors }"
        name="type"
        rules="required"
        mode="lazy"
      >
        <v-select
          v-model="shaft.type"
          :items="typeChoices"
          :error-messages="errors"
          label="Durchmesser/Art *"
          data-vv-name="type"
          item-text="title"
          return-object
          outlined
          color="grey darken-2"
          :disabled="shaft.ordered"
        >
        </v-select>
      </validation-provider>
      <validation-provider
        v-slot="{ errors }"
        name="subtype"
        rules="required"
        mode="lazy"
      >
        <v-select
          v-model="shaft.subtype"
          :items="types"
          :error-messages="errors"
          label="Farbe/Material *"
          data-vv-name="subtype"
          item-text="shaft_options_base_types_id.type"
          item-value="shaft_options_base_types_id.id"
          outlined
          color="grey darken-2"
          :readonly="shaft.ordered"
          :disabled="!shaft.type || shaft.ordered"
        >
        </v-select>
      </validation-provider>
      <div
        class="v-input theme--light v-text-field v-text-field--is-booted v-text-field--enclosed v-text-field--outlined"
      >
        <div class="v-input__control">
          <div class="v-input__slot">
            <fieldset aria-hidden="true">
              <legend style="width: 0px;"></legend>
            </fieldset>
            <div class="v-text-field__slot">
              <label
                :class="
                  !shaft.ordered
                    ? 'v-label theme--light'
                    : 'v-label theme--light v-label--is-disabled'
                "
                style="left: 0px; right: auto; position: absolute; margin-top: -2px"
                >Versetzanker {{ shaft.anchor ? 'Ja' : 'Nein' }}</label
              >
              <v-switch
                v-model="shaft.anchor"
                inset
                class="form-switch ma-0 pa-0"
                :disabled="shaft.ordered"
              ></v-switch>
            </div>
          </div>
          <div class="v-text-field__details">
            <div class="v-messages theme--light">
              <div class="v-messages__wrapper"></div>
            </div>
          </div>
        </div>
      </div>
      <div class="my-4 text-center">
        <v-btn
          color="primary"
          class="text-center"
          type="submit"
          :loading="isSubmitting"
          outlined
        >
          Weiter
        </v-btn>
      </div>
    </form>
  </validation-observer>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  name: 'FormEditShaft1',
  components: {},
  props: ['shaft', 'typeChoices', 'subtypeChoices'],
  data: () => ({
    isSubmitting: false,
    lastType: -1,
  }),
  computed: {
    ...mapGetters([]),
    types() {
      if (this.shaft && this.shaft.type) return this.shaft.type.types;
      return [];
    },
  },
  created() {
    if (this.shaft && this.shaft.type) this.lastType = this.shaft.type.id;
  },
  watch: {
    shaft: {
      handler(newVal) {
        var newId = newVal && newVal.type ? newVal.type.id : -1;
        if (this.lastType >= 0 && this.lastType != newId) {
          // choose first subtype option
          this.shaft.subtype = this.types[0].shaft_options_base_types_id.id;
          // reset all diameters since they are dependent on the type
          if (this.shaft.input_channel)
            this.shaft.input_channel.diameter = null;
          if (this.shaft.output_channel)
            this.shaft.output_channel.diameter = null;
          if (this.shaft.side_channels)
            this.shaft.side_channels.forEach(sideChannel => {
              sideChannel.diameter = null;
            });
        }
        this.lastType = newId;
      },
      deep: true,
    },
  },
  methods: {
    ...mapActions(['updateCurrentShaft']),
    submit() {
      this.$refs.observer.validate().then(async success => {
        if (!success) {
          return;
        }
        this.isSubmitting = true;
        try {
          if (!this.shaft.ordered) await this.updateCurrentShaft(this.shaft);
          this.$emit('submit');
        } catch {
          // ignored
        }
        this.isSubmitting = false;
      });
    },
    clear() {
      this.$refs.observer.reset();
    },
  },
};
</script>

<style scoped>
.form-switch {
  position: absolute;
  right: -7px;
}

.form-switch >>> .v-messages {
  display: none;
}
</style>
